// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';
//     this.minSearchLength = 3;
//     this.allProducts = [];
//     this.fragranceTags = ['floral', 'wood', 'citrus', 'oriental', 'musk', 'woody', 'fruity', 'spicy', 'fresh', 'aquatic','ambery'];
//     this.lastSearchWasFragrance = false;
    
//     this.fragranceMap = window.PRODUCT_FRAGRANCE_MAP || {};
//     this.targetHandles = [
//     'eternal-sapphires-collection',
//     'amber-sapphire-1',
//     'rose-sapphire-1',
//     'violet-sapphire-supercharged',
//     'carbon-sapphire-supercharged'
//   ];

//     this.setupEventListeners();
//     this.loadAllProducts();
    
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   async loadAllProducts() {
//     try {
//       const collectionHandle = 'all';
//       this.allProducts = await this.getAllProductsFromCollection(collectionHandle);
//       console.log(`Loaded ${this.allProducts.length} products for predictive search`);
//     } catch (error) {
//       console.error('Error loading products:', error);
//     }
//   }

//   async getAllProductsFromCollection(collectionHandle) {
//     const limit = 250;
//     let page = 1;
//     let allProducts = [];
//     let hasMoreProducts = true;

//     while (hasMoreProducts) {
//       const url = `/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`;
      
//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             "Accept": "application/json"
//           }
//         });

//         if (!response.ok) {
//           throw new Error(`Request failed: ${response.status}`);
//         }

//         const data = await response.json();
//         const products = data.products || [];
        
//         const processedProducts = products.map(product => {
//           const fragranceFamily = this.getFragranceFamilyFromMap(product.handle);
//           return {
//             ...product,
//             fragranceFamily: fragranceFamily
//           };
//         });
        
//         allProducts = allProducts.concat(processedProducts);
//         console.log(`Fetched page ${page} — ${products.length} products`);

//         if (products.length < limit) {
//           hasMoreProducts = false;
//         } else {
//           page++;
//         }
//       } catch (error) {
//         console.error("Shopify AJAX fetch error:", error);
//         break;
//       }
//     }

//     console.log(`Total products fetched: ${allProducts.length}`);
//     return allProducts;
//   }

//   getFragranceFamilyFromMap(productHandle) {
//     if (!productHandle || !this.fragranceMap) {
//       return null;
//     }
    
//     const fragranceData = this.fragranceMap[productHandle];
    
//     if (fragranceData && fragranceData.fragranceFamily) {
//       return fragranceData.fragranceFamily;
//     }
    
//     return null;
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
    
//     if (newSearchTerm.length < this.minSearchLength) {
//       this.close(false);
//       return;
//     }
    
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
//     }

//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);
//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = '';
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (currentSearchTerm.length < this.minSearchLength) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       // if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case 'ArrowUp':
//         this.switchOption('up');
//         break;
//       case 'ArrowDown':
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
//       (element) => element.offsetParent !== null
//     );
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = '';

//     if (!moveUp && selectedElement) {
//       activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute('aria-selected', true);
//     if (selectedElement) selectedElement.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
//     if (selectedOption) selectedOption.click();
//   }

//   isFragranceSearch(searchTerm) {
//     const normalizedSearch = searchTerm.toLowerCase();
    
//     return this.fragranceTags.some(tag => {
//       const normalizedTag = tag.toLowerCase();
//       return normalizedTag.startsWith(normalizedSearch) || 
//              normalizedTag.includes(normalizedSearch) || 
//              normalizedSearch.includes(normalizedTag);
//     });
//   }

//   // ─── UPDATED: getSearchResults with broader keyword merging ───────────────
//   // getSearchResults(searchTerm) {
//   //   if (searchTerm.length < this.minSearchLength) {
//   //     this.close(false);
//   //     return;
//   //   }

//   //   const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
//   //   this.setLiveRegionLoadingState();

//   //   // Fragrance search path — untouched
//   //   if (this.isFragranceSearch(searchTerm)) {
//   //     this.lastSearchWasFragrance = true;
//   //     this.filterProductsByFragrance(searchTerm);
//   //     return;
//   //   }

//   //   // Clear any previous fragrance results immediately
//   //   this.lastSearchWasFragrance = false;
//   //   this.predictiveSearchResults.innerHTML = `
//   //     <div class="predictive-search__loading">
//   //       <span class="loading-text">Loading results…</span>
//   //     </div>
//   //   `;
//   //   this.setAttribute('loading', true);
//   //   this.removeAttribute('results');
//   //   this.setLiveRegionLoadingState();

//   //   // Return cached merged result if available
//   //   if (this.cachedResults[queryKey]) {
//   //     this.renderSearchResults(this.cachedResults[queryKey]);
//   //     return;
//   //   }

//   //   // Fetch 1: exact search (e.g. "eternal sapphires")
//   //   const exactFetch = fetch(
//   //     `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
//   //     { signal: this.abortController.signal }
//   //   ).then(r => {
//   //     if (!r.ok) throw new Error(r.status);
//   //     return r.text();
//   //   });

//   //   // Fetch 2: broader keyword search (e.g. "sapphire")
//   //   const broaderKeyword = this.extractBroaderKeyword(searchTerm);
//   //   const broaderFetch = broaderKeyword
//   //     ? fetch(
//   //         `${routes.predictive_search_url}?q=${encodeURIComponent(broaderKeyword)}&section_id=predictive-search`,
//   //         { signal: this.abortController.signal }
//   //       ).then(r => r.ok ? r.text() : Promise.resolve(null))
//   //     : Promise.resolve(null);

//   //   Promise.all([exactFetch, broaderFetch])
//   //     .then(([exactText, broaderText]) => {
//   //       const exactDoc = new DOMParser().parseFromString(exactText, 'text/html');
//   //       const exactMarkup = exactDoc.querySelector('#shopify-section-predictive-search').innerHTML;

//   //       let mergedMarkup = exactMarkup;

//   //       if (broaderText) {
//   //         const broaderDoc = new DOMParser().parseFromString(broaderText, 'text/html');
//   //         mergedMarkup = this.mergeSearchResults(exactMarkup, broaderDoc);
//   //       }

//   //       // Cache the merged result
//   //       this.allPredictiveSearchInstances.forEach(instance => {
//   //         instance.cachedResults[queryKey] = mergedMarkup;
//   //       });

//   //       this.renderSearchResults(mergedMarkup);
//   //     })
//   //     .catch((error) => {
//   //       if (error?.code === 20) return; // Aborted fetch
//   //       this.close();
//   //       throw error;
//   //     });
//   // }
//   getSearchResults(searchTerm) {
//   if (searchTerm.length < this.minSearchLength) {
//     this.close(false);
//     return;
//   }

//   const normalizedSearch = searchTerm.toLowerCase();

//   // ✅ SPECIAL CASE: Eternal Sapphires
//   const isEternalSearch = normalizedSearch.includes('eternal sapphires');

//   const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
//   this.setLiveRegionLoadingState();

//   if (this.isFragranceSearch(searchTerm)) {
//     this.lastSearchWasFragrance = true;
//     this.filterProductsByFragrance(searchTerm);
//     return;
//   }

//   this.lastSearchWasFragrance = false;

//   this.predictiveSearchResults.innerHTML = `
//     <div class="predictive-search__loading">
//       <span class="loading-text">Loading results…</span>
//     </div>
//   `;

//   this.setAttribute('loading', true);
//   this.removeAttribute('results');

//   // 🔥 Increase limit ONLY for Eternal search
//   const limitParam = isEternalSearch ? '&resources[limit]=10' : '';

//   const exactFetch = fetch(
//     `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}${limitParam}&section_id=predictive-search`,
//     { signal: this.abortController.signal }
//   ).then(r => {
//     if (!r.ok) throw new Error(r.status);
//     return r.text();
//   });

//   const broaderKeyword = this.extractBroaderKeyword(searchTerm);

//   const broaderFetch = broaderKeyword
//     ? fetch(
//         `${routes.predictive_search_url}?q=${encodeURIComponent(broaderKeyword)}${limitParam}&section_id=predictive-search`,
//         { signal: this.abortController.signal }
//       ).then(r => r.ok ? r.text() : null)
//     : Promise.resolve(null);

//   Promise.all([exactFetch, broaderFetch])
//     .then(([exactText, broaderText]) => {
//       const exactDoc = new DOMParser().parseFromString(exactText, 'text/html');
//       let mergedMarkup = exactDoc.querySelector('#shopify-section-predictive-search').innerHTML;

//       if (broaderText) {
//         const broaderDoc = new DOMParser().parseFromString(broaderText, 'text/html');
//         mergedMarkup = this.mergeSearchResults(mergedMarkup, broaderDoc);
//       }

//       // ✅ CUSTOM INSERT (only for Eternal)
//       if (isEternalSearch) {
//         mergedMarkup = this.injectEternalProducts(mergedMarkup);
//       }

//       this.allPredictiveSearchInstances.forEach(instance => {
//         instance.cachedResults[queryKey] = mergedMarkup;
//       });

//       this.renderSearchResults(mergedMarkup);
//     })
//     .catch((error) => {
//       if (error?.code === 20) return;
//       this.close();
//       throw error;
//     });
// }
// injectEternalProducts(existingMarkup) {
//   // const targetHandles = [
//   //   'eternal-sapphires-collection',
//   //   'amber-sapphire-1',
//   //   'rose-sapphire-1',
//   //   'violet-sapphire-supercharged',
//   //   'carbon-sapphire-supercharged'
//   // ];
//   const targetHandles = this.targetHandles;

//   const tempDiv = document.createElement('div');
//   tempDiv.innerHTML = existingMarkup;

//   const productList = tempDiv.querySelector(
//     '.predictive-search__results-list[aria-labelledby="predictive-search-products"], ul[id*="products-list"]'
//   );

//   if (!productList) return existingMarkup;

//   const existingHandles = new Set();

//   productList.querySelectorAll('a[href*="/products/"]').forEach(link => {
//     const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
//     if (match) existingHandles.add(match[1]);
//   });

//   // ✅ Find missing products from ALL PRODUCTS
//   const missingProducts = this.allProducts.filter(product =>
//     targetHandles.includes(product.handle) && !existingHandles.has(product.handle)
//   );

//   // ✅ Convert to HTML using your existing renderer
//   // const newItemsHTML = missingProducts.map((product, index) =>
//   //   this.generateProductHTML(product, index, '')
//   // ).join('');
//     const newItemsHTML = missingProducts.map((product, index) => {
//       const targetIndex = targetHandles.indexOf(product.handle) + 1;
//       return this.generateProductHTML(product, index, '', targetIndex);
//     }).join('');

//   // ✅ Insert at TOP
//   productList.insertAdjacentHTML('afterbegin', newItemsHTML);

//   return tempDiv.innerHTML;
// }

//   // ─── NEW: Extract a broader keyword from a multi-word query ───────────────
//   // "eternal sapphires" → "sapphire"
//   // "blue floral musk"  → "musk"
//   // "sapphire"          → null (single word, no broader needed)
//   extractBroaderKeyword(searchTerm) {
//     const words = searchTerm.trim().toLowerCase().split(/\s+/);

//     // Single word query — no broader keyword needed
//     if (words.length <= 1) return null;

//     // Take the last word as the broader keyword
//     let keyword = words[words.length - 1];

//     // Simple depluralize: strip trailing 's' if word is longer than 4 chars
//     // "sapphires" → "sapphire", "roses" → "rose", but "musk" stays "musk"
//     if (keyword.endsWith('s') && keyword.length > 4) {
//       keyword = keyword.slice(0, -1);
//     }

//     return keyword;
//   }

//   // ─── NEW: Merge broader results into exact results, skip duplicates ────────
//   mergeSearchResults(exactMarkup, broaderDoc) {
//     // Parse exact markup into a temp container
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = exactMarkup;

//     // Collect product handles already present in exact results
//     const existingHandles = new Set();
//     tempDiv.querySelectorAll('a[href*="/products/"]').forEach(link => {
//       const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
//       if (match) existingHandles.add(match[1]);
//     });

//     // Find the product list in exact results to append into
//     const exactProductList = tempDiv.querySelector(
//       '.predictive-search__results-list[aria-labelledby="predictive-search-products"], ' +
//       'ul[id*="products-list"]'
//     );

//     // If no product list found, return original markup untouched
//     if (!exactProductList) return exactMarkup;

//     // Get product list items from broader results
//     const broaderItems = broaderDoc.querySelectorAll(
//       '.predictive-search__results-list[aria-labelledby="predictive-search-products"] li, ' +
//       'ul[id*="products-list"] li'
//     );

//     broaderItems.forEach(item => {
//       const link = item.querySelector('a[href*="/products/"]');
//       if (!link) return;

//       const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
//       if (!match) return;

//       const handle = match[1];

//       // Skip if this product is already in exact results
//       if (existingHandles.has(handle)) return;

//       existingHandles.add(handle);
//       exactProductList.appendChild(item.cloneNode(true));
//     });

//     return tempDiv.innerHTML;
//   }
//   // ─────────────────────────────────────────────────────────────────────────

//   filterProductsByFragrance(searchTerm) {
//     const normalizedSearch = searchTerm.toLowerCase();
    
//     const matchingProducts = this.allProducts.filter(product => {
//       const fragranceFamily = product.fragranceFamily;
      
//       if (!fragranceFamily) return false;
      
//       const normalizedFamily = String(fragranceFamily).toLowerCase();
      
//       return normalizedFamily.startsWith(normalizedSearch) || 
//              normalizedFamily.includes(normalizedSearch) || 
//              normalizedSearch.includes(normalizedFamily);
//     });

//     this.renderFragranceResults(matchingProducts, searchTerm);
//   }

//   highlightText(text, searchTerm) {
//     if (!searchTerm || !text) return text;
    
//     const regex = new RegExp(`(${searchTerm})`, 'ig');
//     return text.replace(regex, '<mark>$1</mark>');
//   }

//   renderFragranceResults(products, searchTerm) {
//     let wrapper = this.predictiveSearchResults.querySelector('#predictive-search-results-groups-wrapper');
//     let metafieldSearchList = this.predictiveSearchResults.querySelector('.js-metafield-search');
    
//     if (!wrapper) {
//       console.log('Creating predictive-search-results-groups-wrapper for fragrance results');
      
//       this.predictiveSearchResults.innerHTML = '';
      
//       const wrapperHTML = `
//         <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">
//           <div class="predictive-search__result-group">
//             <div>
//               <h2 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">Popular Searches</h2>
//               <ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries">
//               </ul>
//             </div>
//           </div>
//            </div>
//           <div class="predictive-search__recommendations-meta">
//             <h3 class="predictive-search__heading" id="predictive-search-products">Top Suggestions</h3>
//             <ul
//               id="predictive-search-results-products-list"
//               class="predictive-search__results-list list-unstyled product-list-grid js-metafield-search"
//               role="listbox"
//               data-random-products
//               aria-labelledby="predictive-search-products">
//             </ul>
//           </div>
//           <span data-predictive-search-live-region-count-value style="display: none;"></span>
        
//         </div>
//         <div class="predictive-search__search-for-button">
//             <button
//         class="theme-button predictive-search__item predictive-search__item--term link link--text h5 animate-arrow"
//         tabindex="-1"
//         role="option"
//         aria-selected="false"
//       >
        
//         <span>Search all</span>
        
//       </button>
//       </div>
//       `;
      
//       this.predictiveSearchResults.insertAdjacentHTML('beforeend', wrapperHTML);
//       wrapper = this.predictiveSearchResults.querySelector('#predictive-search-results-groups-wrapper');
//       metafieldSearchList = this.predictiveSearchResults.querySelector('.js-metafield-search');
//     }

//     const popularSearchesList = wrapper.querySelector('#predictive-search-results-queries-list');

//     if (metafieldSearchList) {
//       metafieldSearchList.innerHTML = '';
//     } else {
//       console.error('Failed to create or find .js-metafield-search container');
//       this.removeAttribute('loading');
//       return;
//     }

//     if (products.length === 0) {
//       if (popularSearchesList) {
//         popularSearchesList.innerHTML = '';
//       }
      
//       metafieldSearchList.innerHTML = `
//         <li class="predictive-search__list-item">
//           <p class="predictive-search__no-results">No products found for "${searchTerm}"</p>
//         </li>
//       `;
//       this.updateFragranceResultCount(0, searchTerm);
//       this.setAttribute('results', true);
//       this.removeAttribute('loading');
//       this.open();
//       this.showRandomProductsWhenNoResults();
//       return;
//     }

//     if (popularSearchesList && products.length > 0) {
//       const firstProduct = products[0];
//       const fragranceFamily = firstProduct.fragranceFamily;
//       const firstProductHandle = firstProduct.handle;
      
//       if (fragranceFamily && firstProductHandle) {
//         const displayFamily = fragranceFamily.charAt(0).toUpperCase() + fragranceFamily.slice(1);
//         const highlightedFamily = this.highlightText(displayFamily, searchTerm);

//         popularSearchesList.innerHTML = `
//           <li id="predictive-search-option-query-1" class="predictive-search__list-item" role="option" aria-selected="false">
//               <a href="/search?q=${fragranceFamily}&options%5Bprefix%5D=last" class="predictive-search__item link link--text" tabindex="-1">
//                 <div class="predictive-search__item-content predictive-search__item-content--centered" bis_skin_checked="1">
//                   <p class="predictive-search__item-heading predictive-search__item-query-result h5" aria-label="${displayFamily}" data-predictive-search-text>
//                    ${highlightedFamily}
//                   </p>
//                 </div>
//               </a>
//             </li>
//         `;
//       }
//     }

//     products.forEach((product, index) => {
//       const productHTML = this.generateProductHTML(product, index, searchTerm);
//       metafieldSearchList.insertAdjacentHTML('beforeend', productHTML);
//     });

//     this.updateFragranceResultCount(products.length, searchTerm);
//     this.setAttribute('results', true);
//     this.removeAttribute('loading');
//     this.open();
    
//     setTimeout(() => {
//       this.highlightMatches(searchTerm);
//     }, 100);
    
//     this.attachQuickBuyListeners();
//   }

//   updateFragranceResultCount(count, searchTerm) {
//     const countElement = this.predictiveSearchResults.querySelector('[data-predictive-search-live-region-count-value]');
//     if (countElement) {
//       const countText = count === 0 
//         ? `No results found for "${searchTerm}"` 
//         : `${count} result${count !== 1 ? 's' : ''} found for "${searchTerm}"`;
//       countElement.textContent = countText;
      
//       if (this.statusElement) {
//         this.setLiveRegionText(countText);
//       }
//     }
//   }

//   generateProductHTML(product, index, searchTerm, resultIndex) {
//     const fragranceFamily = product.fragranceFamily || '';
//     const firstVariant = product.variants?.[0];
//     const productImage = product.images?.[0]?.src || product.image?.src || '';
//     const productTitle = product.title || '';
//     const productHandle = product.handle || '';
//     const productId = product.id || '';
    
//     let variantsHTML = '';
//     if (product.variants && product.variants.length > 0) {
//       variantsHTML = product.variants.map(variant => {
//         const price = this.formatMoney(variant.price);
//         return `
//           <li data-variant-id="${variant.id}" data-price="${price}">
//             <span class="opt-lable">${variant.title}</span>
//             <span class="opt-price">${price}</span>
//           </li>
//         `;
//       }).join('');
//     }

//     const tags = product.tags || [];
//     let badgeHTML = '';
//     if (fragranceFamily) {
//       badgeHTML = `<span class="pro-grid-tag badge">${fragranceFamily}</span>`;
//     }

//     return `
//       <li id="predictive-search-option-product-${index}" 
//           class="predictive-search__list-item random-product-predictive-search is-visible" 
//           role="option" 
//           aria-selected="false"
//           data-fragrance-family="${fragranceFamily}"
//         ${this.targetHandles ? `data-result-index="${this.targetHandles.indexOf(productHandle) !== -1 ? this.targetHandles.indexOf(productHandle) + 1 : index}"` : `data-result-index="${index}"`}>
        
//         <div class="card-wrapper product-card-wrapper underline-links-hover card-grid">
//           <div class="card card--standard card--media" style="--ratio-percent: 100%;">
//             <div class="card__inner color-scheme-ad6ebdc0-7e7b-4a79-a915-0a8201d7232c gradient ratio" style="--ratio-percent: 100%;">
//               <div class="pro-cart-button js-pro-cart-button">
//                 <a href="javascript:void(0)">
//                   <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M8 5.83333V3.16667C8 1.69391 6.88071 0.5 5.5 0.5C4.11929 0.5 3 1.69391 3 3.16667V5.83333M1.125 4.5H9.875L10.5 12.5H0.5L1.125 4.5Z" stroke="#705938" stroke-linecap="round" stroke-linejoin="round"></path>
//                   </svg>
//                   <span class="button-text">Quick Buy</span>
//                 </a>
//               </div>

//               <div class="card__media">
//                 <div class="media media--transparent media--hover-effect">
//                   ${productImage ? `
//                     <img src="${productImage}" 
//                          alt="${productTitle}" 
//                          class="motion-reduce" 
//                          loading="lazy" 
//                          width="533" 
//                          height="533">
//                   ` : ''}
//                 </div>
//               </div>

//               <div class="card__content">
//                 <a href="/products/${productHandle}" class="pro-img-link"></a>
//                 <div class="card__information">
//                   <h3 class="card__heading">
//                     <a href="/products/${productHandle}" 
//                        id="StandardCardNoMediaLink-predictive-search-${productId}" 
//                        class="full-unstyled-link" 
//                        data-predictive-search-text
//                        aria-labelledby="StandardCardNoMediaLink-predictive-search-${productId}">
//                       ${productTitle}
//                     </a>
//                   </h3>
//                 </div>
//                 <div class="card__badge top right">
//                   ${badgeHTML}
//                 </div>
//               </div>
//             </div>

//             <div class="card__content">
//               <div class="card__information">
//                 <h3 class="card__heading h5" id="title-predictive-search-${productId}">
//                   <a href="/products/${productHandle}" 
//                      id="CardLink-predictive-search-${productId}" 
//                      class="full-unstyled-link" 
//                      data-predictive-search-text
//                      aria-labelledby="CardLink-predictive-search-${productId}">
//                     ${productTitle}
//                   </a>
//                 </h3>
                
//                 ${variantsHTML ? `
//                   <ul class="card-option">
//                     ${variantsHTML}
//                   </ul>
//                 ` : ''}
                
//                 <div class="card-information">
//                   <span class="caption-large light"></span>
//                 </div>
//               </div>

//               <div class="quick-add no-js-hidden hidden">
//                 <modal-opener data-modal="#QuickAdd-${productId}">
//                   <button id="quick-add-predictive-search${productId}-submit" 
//                           type="submit" 
//                           name="add" 
//                           class="quick-add__submit button button--full-width button--secondary" 
//                           aria-haspopup="dialog" 
//                           aria-labelledby="quick-add-predictive-search${productId}-submit title-predictive-search-${productId}" 
//                           data-product-url="/products/${productHandle}">
//                     Choose options
//                     <div class="loading__spinner hidden">
//                       <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                         <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//                       </svg>
//                     </div>
//                   </button>
//                 </modal-opener>
//               </div>

//               <div class="card__badge top right"></div>
//             </div>
//           </div>
//         </div>
//       </li>
//     `;
//   }

//   formatMoney(cents) {
//     const amount = cents / 100;
//     return `£${amount.toFixed(2)}`;
//   }

//   attachQuickBuyListeners() {
//     const quickViewButtons = this.predictiveSearchResults.querySelectorAll('.js-pro-cart-button');

//     quickViewButtons.forEach(button => {
//       button.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();

//         const card = e.currentTarget.closest('.card--standard');
//         if (!card) return;

//         const quickAddButton = card.querySelector('.quick-add__submit');
//         if (quickAddButton) {
//           const cleanClick = new Event('click', { bubbles: true });
//           quickAddButton.dispatchEvent(cleanClick);
//         }
//       });
//     });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
//     this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   highlightMatches(searchTerm) {
//     if (!searchTerm) return;

//     const regex = new RegExp(`(${searchTerm})`, 'ig');

//     this.predictiveSearchResults
//       .querySelectorAll('[data-predictive-search-text]')
//       .forEach((el) => {
//         const originalText = el.textContent;

//         if (el.innerHTML.includes('<mark>')) return;

//         el.innerHTML = originalText.replace(regex, '<mark>$1</mark>');
//       });
//   }

//   showRandomProductsWhenNoResults() {
//     const container = this.predictiveSearchResults;
//     if (!container) return;

//     const noResults = container.querySelector('.predictive-search__recommendations');
//     if (!noResults) return;
   
//     const items = Array.from(
//       container.querySelectorAll('.random-product-predictive-search')
//     );

//     if (!items.length) return;

//     items.forEach(li => li.classList.remove('is-visible'));

//     for (let i = items.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [items[i], items[j]] = [items[j], items[i]];
//     }

//     items.slice(0, 5).forEach(li => {
//       li.classList.add('is-visible');
//     });
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', true);

//     this.setLiveRegionResults();
//     this.open();
//     this.highlightMatches(this.searchTerm);
    
//     const quickViewButtons = this.predictiveSearchResults.querySelectorAll('.js-pro-cart-button');
//     this.showRandomProductsWhenNoResults();

//     quickViewButtons.forEach(button => {
//       button.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();

//         const card = e.currentTarget.closest('.card--standard');
//         if (!card) return;

//         const quickAddButton = card.querySelector('.quick-add__submit');
//         if (quickAddButton) {
//           const cleanClick = new Event('click', { bubbles: true });
//           quickAddButton.dispatchEvent(cleanClick);
//         }
//       });
//     });
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     const countElement = this.querySelector('[data-predictive-search-live-region-count-value]');
//     if (countElement) {
//       this.setLiveRegionText(countElement.textContent);
//     }
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute('open', true);
//     this.input.setAttribute('aria-expanded', true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//     }
//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute('style');
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);


class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.minSearchLength = 3;
    this.allProducts = [];
    this.fragranceTags = ['floral', 'wood', 'citrus', 'oriental', 'musk', 'woody', 'fruity', 'spicy', 'fresh', 'aquatic','ambery'];
    this.lastSearchWasFragrance = false;
    this.fragranceMap = window.PRODUCT_FRAGRANCE_MAP || {};
    this.targetHandles = [
      'eternal-sapphires-collection',
      'rose-sapphire-1',
      'amber-sapphire-1',
      'violet-sapphire-supercharged',
      'carbon-sapphire-supercharged'
    ];

    this.setupEventListeners();
    this.loadAllProducts();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  async loadAllProducts() {
    try {
      const collectionHandle = 'all';
      this.allProducts = await this.getAllProductsFromCollection(collectionHandle);
      console.log(`Loaded ${this.allProducts.length} products for predictive search`);
    } catch (error) {
      console.error('Error loading products:', error);
    }
  }

  async getAllProductsFromCollection(collectionHandle) {
    const limit = 250;
    let page = 1;
    let allProducts = [];
    let hasMoreProducts = true;

    while (hasMoreProducts) {
      const url = `/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`;
      
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Accept": "application/json"
          }
        });

        if (!response.ok) {
          throw new Error(`Request failed: ${response.status}`);
        }

        const data = await response.json();
        const products = data.products || [];
        
        const processedProducts = products.map(product => {
          const fragranceFamily = this.getFragranceFamilyFromMap(product.handle);
          return {
            ...product,
            fragranceFamily: fragranceFamily
          };
        });
        
        allProducts = allProducts.concat(processedProducts);
        console.log(`Fetched page ${page} — ${products.length} products`);

        if (products.length < limit) {
          hasMoreProducts = false;
        } else {
          page++;
        }
      } catch (error) {
        console.error("Shopify AJAX fetch error:", error);
        break;
      }
    }

    console.log(`Total products fetched: ${allProducts.length}`);
    return allProducts;
  }

  getFragranceFamilyFromMap(productHandle) {
    if (!productHandle || !this.fragranceMap) {
      return null;
    }
    
    const fragranceData = this.fragranceMap[productHandle];
    
    if (fragranceData && fragranceData.fragranceFamily) {
      return fragranceData.fragranceFamily;
    }
    
    return null;
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    
    if (newSearchTerm.length < this.minSearchLength) {
      this.close(false);
      return;
    }
    
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (currentSearchTerm.length < this.minSearchLength) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      // if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) selectedOption.click();
  }

  isFragranceSearch(searchTerm) {
    const normalizedSearch = searchTerm.toLowerCase();
    
    return this.fragranceTags.some(tag => {
      const normalizedTag = tag.toLowerCase();
      return normalizedTag.startsWith(normalizedSearch) || 
             normalizedTag.includes(normalizedSearch) || 
             normalizedSearch.includes(normalizedTag);
    });
  }

  getSearchResults(searchTerm) {
    if (searchTerm.length < this.minSearchLength) {
      this.close(false);
      return;
    }

    const normalizedSearch = searchTerm.toLowerCase();
    const isEternalSearch = normalizedSearch.includes('eternal sapphires');
    const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.isFragranceSearch(searchTerm)) {
      this.lastSearchWasFragrance = true;
      this.filterProductsByFragrance(searchTerm);
      return;
    }

    this.lastSearchWasFragrance = false;

    this.predictiveSearchResults.innerHTML = `
      <div class="predictive-search__loading">
        <span class="loading-text">Loading results…</span>
      </div>
    `;

    this.setAttribute('loading', true);
    this.removeAttribute('results');

    const limitParam = isEternalSearch ? '&resources[limit]=10' : '';

    const exactFetch = fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}${limitParam}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    ).then(r => {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });

    const broaderKeyword = this.extractBroaderKeyword(searchTerm);

    const broaderFetch = broaderKeyword
      ? fetch(
          `${routes.predictive_search_url}?q=${encodeURIComponent(broaderKeyword)}${limitParam}&section_id=predictive-search`,
          { signal: this.abortController.signal }
        ).then(r => r.ok ? r.text() : null)
      : Promise.resolve(null);

    Promise.all([exactFetch, broaderFetch])
      .then(([exactText, broaderText]) => {
        const exactDoc = new DOMParser().parseFromString(exactText, 'text/html');
        let mergedMarkup = exactDoc.querySelector('#shopify-section-predictive-search').innerHTML;

        if (broaderText) {
          const broaderDoc = new DOMParser().parseFromString(broaderText, 'text/html');
          mergedMarkup = this.mergeSearchResults(mergedMarkup, broaderDoc);
        }

        if (isEternalSearch) {
          mergedMarkup = this.injectEternalProducts(mergedMarkup);
        }

        this.allPredictiveSearchInstances.forEach(instance => {
          instance.cachedResults[queryKey] = mergedMarkup;
        });

        this.renderSearchResults(mergedMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }

  injectEternalProducts(existingMarkup) {
    const targetHandles = this.targetHandles;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = existingMarkup;

    const productList = tempDiv.querySelector(
      '.predictive-search__results-list[aria-labelledby="predictive-search-products"], ul[id*="products-list"]'
    );

    if (!productList) return existingMarkup;

    const existingHandles = new Set();

    productList.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (match) existingHandles.add(match[1]);
    });

    // Also inject data-result-index into already existing li items that match targetHandles
    productList.querySelectorAll('li').forEach(li => {
      const link = li.querySelector('a[href*="/products/"]');
      if (!link) return;
      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      const handle = match[1];
      const targetIndex = targetHandles.indexOf(handle);
      if (targetIndex !== -1) {
        li.setAttribute('data-result-index', targetIndex + 1);
      }
    });

    const missingProducts = this.allProducts.filter(product =>
      targetHandles.includes(product.handle) && !existingHandles.has(product.handle)
    );

    const newItemsHTML = missingProducts.map((product, index) => {
      const targetIndex = targetHandles.indexOf(product.handle) + 1;
      return this.generateProductHTML(product, index, '', targetIndex);
    }).join('');

    productList.insertAdjacentHTML('afterbegin', newItemsHTML);

    return tempDiv.innerHTML;
  }

  extractBroaderKeyword(searchTerm) {
    const words = searchTerm.trim().toLowerCase().split(/\s+/);

    if (words.length <= 1) return null;

    let keyword = words[words.length - 1];

    if (keyword.endsWith('s') && keyword.length > 4) {
      keyword = keyword.slice(0, -1);
    }

    return keyword;
  }

  mergeSearchResults(exactMarkup, broaderDoc) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = exactMarkup;

    const existingHandles = new Set();
    tempDiv.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (match) existingHandles.add(match[1]);
    });

    const exactProductList = tempDiv.querySelector(
      '.predictive-search__results-list[aria-labelledby="predictive-search-products"], ' +
      'ul[id*="products-list"]'
    );

    if (!exactProductList) return exactMarkup;

    const broaderItems = broaderDoc.querySelectorAll(
      '.predictive-search__results-list[aria-labelledby="predictive-search-products"] li, ' +
      'ul[id*="products-list"] li'
    );

    broaderItems.forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link) return;

      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;

      const handle = match[1];

      if (existingHandles.has(handle)) return;

      existingHandles.add(handle);
      exactProductList.appendChild(item.cloneNode(true));
    });

    return tempDiv.innerHTML;
  }

  filterProductsByFragrance(searchTerm) {
    const normalizedSearch = searchTerm.toLowerCase();
    
    const matchingProducts = this.allProducts.filter(product => {
      const fragranceFamily = product.fragranceFamily;
      
      if (!fragranceFamily) return false;
      
      const normalizedFamily = String(fragranceFamily).toLowerCase();
      
      return normalizedFamily.startsWith(normalizedSearch) || 
             normalizedFamily.includes(normalizedSearch) || 
             normalizedSearch.includes(normalizedFamily);
    });

    this.renderFragranceResults(matchingProducts, searchTerm);
  }

  highlightText(text, searchTerm) {
    if (!searchTerm || !text) return text;
    
    const regex = new RegExp(`(${searchTerm})`, 'ig');
    return text.replace(regex, '<mark>$1</mark>');
  }

  renderFragranceResults(products, searchTerm) {
    let wrapper = this.predictiveSearchResults.querySelector('#predictive-search-results-groups-wrapper');
    let metafieldSearchList = this.predictiveSearchResults.querySelector('.js-metafield-search');
    
    if (!wrapper) {
      console.log('Creating predictive-search-results-groups-wrapper for fragrance results');
      
      this.predictiveSearchResults.innerHTML = '';
      
      const wrapperHTML = `
        <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">
          <div class="predictive-search__result-group">
            <div>
              <h2 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">Popular Searches</h2>
              <ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries">
              </ul>
            </div>
          </div>
           </div>
          <div class="predictive-search__recommendations-meta">
            <h3 class="predictive-search__heading" id="predictive-search-products">Top Suggestions</h3>
            <ul
              id="predictive-search-results-products-list"
              class="predictive-search__results-list list-unstyled product-list-grid js-metafield-search"
              role="listbox"
              data-random-products
              aria-labelledby="predictive-search-products">
            </ul>
          </div>
          <span data-predictive-search-live-region-count-value style="display: none;"></span>
        
        </div>
        <div class="predictive-search__search-for-button">
            <button
        class="theme-button predictive-search__item predictive-search__item--term link link--text h5 animate-arrow"
        tabindex="-1"
        role="option"
        aria-selected="false"
      >
        
        <span>Search all</span>
        
      </button>
      </div>
      `;
      
      this.predictiveSearchResults.insertAdjacentHTML('beforeend', wrapperHTML);
      wrapper = this.predictiveSearchResults.querySelector('#predictive-search-results-groups-wrapper');
      metafieldSearchList = this.predictiveSearchResults.querySelector('.js-metafield-search');
    }

    const popularSearchesList = wrapper.querySelector('#predictive-search-results-queries-list');

    if (metafieldSearchList) {
      metafieldSearchList.innerHTML = '';
    } else {
      console.error('Failed to create or find .js-metafield-search container');
      this.removeAttribute('loading');
      return;
    }

    if (products.length === 0) {
      if (popularSearchesList) {
        popularSearchesList.innerHTML = '';
      }
      
      metafieldSearchList.innerHTML = `
        <li class="predictive-search__list-item">
          <p class="predictive-search__no-results">No products found for "${searchTerm}"</p>
        </li>
      `;
      this.updateFragranceResultCount(0, searchTerm);
      this.setAttribute('results', true);
      this.removeAttribute('loading');
      this.open();
      this.showRandomProductsWhenNoResults();
      return;
    }

    if (popularSearchesList && products.length > 0) {
      const firstProduct = products[0];
      const fragranceFamily = firstProduct.fragranceFamily;
      const firstProductHandle = firstProduct.handle;
      
      if (fragranceFamily && firstProductHandle) {
        const displayFamily = fragranceFamily.charAt(0).toUpperCase() + fragranceFamily.slice(1);
        const highlightedFamily = this.highlightText(displayFamily, searchTerm);

        popularSearchesList.innerHTML = `
          <li id="predictive-search-option-query-1" class="predictive-search__list-item" role="option" aria-selected="false">
              <a href="/search?q=${fragranceFamily}&options%5Bprefix%5D=last" class="predictive-search__item link link--text" tabindex="-1">
                <div class="predictive-search__item-content predictive-search__item-content--centered" bis_skin_checked="1">
                  <p class="predictive-search__item-heading predictive-search__item-query-result h5" aria-label="${displayFamily}" data-predictive-search-text>
                   ${highlightedFamily}
                  </p>
                </div>
              </a>
            </li>
        `;
      }
    }

    products.forEach((product, index) => {
      const targetIndex = this.targetHandles.indexOf(product.handle);
      const resultIndex = targetIndex !== -1 ? targetIndex + 1 : undefined;
      const productHTML = this.generateProductHTML(product, index, searchTerm, resultIndex);
      metafieldSearchList.insertAdjacentHTML('beforeend', productHTML);
    });

    this.updateFragranceResultCount(products.length, searchTerm);
    this.setAttribute('results', true);
    this.removeAttribute('loading');
    this.open();
    
    setTimeout(() => {
      this.highlightMatches(searchTerm);
    }, 100);
    
    this.attachQuickBuyListeners();
  }

  updateFragranceResultCount(count, searchTerm) {
    const countElement = this.predictiveSearchResults.querySelector('[data-predictive-search-live-region-count-value]');
    if (countElement) {
      const countText = count === 0 
        ? `No results found for "${searchTerm}"` 
        : `${count} result${count !== 1 ? 's' : ''} found for "${searchTerm}"`;
      countElement.textContent = countText;
      
      if (this.statusElement) {
        this.setLiveRegionText(countText);
      }
    }
  }

  generateProductHTML(product, index, searchTerm, resultIndex) {
    const fragranceFamily = product.fragranceFamily || '';
    const firstVariant = product.variants?.[0];
    const productImage = product.images?.[0]?.src || product.image?.src || '';
    const productTitle = product.title || '';
    const productHandle = product.handle || '';
    const productId = product.id || '';

    const targetIndex = this.targetHandles.indexOf(productHandle);
    const finalResultIndex = resultIndex !== undefined ? resultIndex : (targetIndex !== -1 ? targetIndex + 1 : index);
    
    let variantsHTML = '';
    if (product.variants && product.variants.length > 0) {
      variantsHTML = product.variants.map(variant => {
        const price = this.formatMoney(variant.price);
        return `
          <li data-variant-id="${variant.id}" data-price="${price}">
            <span class="opt-lable">${variant.title}</span>
            <span class="opt-price">${price}</span>
          </li>
        `;
      }).join('');
    }

    const tags = product.tags || [];
    let badgeHTML = '';
    if (fragranceFamily) {
      badgeHTML = `<span class="pro-grid-tag badge">${fragranceFamily}</span>`;
    }

    return `
      <li id="predictive-search-option-product-${index}" 
          class="predictive-search__list-item random-product-predictive-search is-visible" 
          role="option" 
          aria-selected="false"
          data-fragrance-family="${fragranceFamily}"
          data-result-index="${finalResultIndex}">
        
        <div class="card-wrapper product-card-wrapper underline-links-hover card-grid">
          <div class="card card--standard card--media" style="--ratio-percent: 100%;">
            <div class="card__inner color-scheme-ad6ebdc0-7e7b-4a79-a915-0a8201d7232c gradient ratio" style="--ratio-percent: 100%;">
              <div class="pro-cart-button js-pro-cart-button">
                <a href="javascript:void(0)">
                  <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5.83333V3.16667C8 1.69391 6.88071 0.5 5.5 0.5C4.11929 0.5 3 1.69391 3 3.16667V5.83333M1.125 4.5H9.875L10.5 12.5H0.5L1.125 4.5Z" stroke="#705938" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span class="button-text">Quick Buy</span>
                </a>
              </div>

              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  ${productImage ? `
                    <img src="${productImage}" 
                         alt="${productTitle}" 
                         class="motion-reduce" 
                         loading="lazy" 
                         width="533" 
                         height="533">
                  ` : ''}
                </div>
              </div>

              <div class="card__content">
                <a href="/products/${productHandle}" class="pro-img-link"></a>
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="/products/${productHandle}" 
                       id="StandardCardNoMediaLink-predictive-search-${productId}" 
                       class="full-unstyled-link" 
                       data-predictive-search-text
                       aria-labelledby="StandardCardNoMediaLink-predictive-search-${productId}">
                      ${productTitle}
                    </a>
                  </h3>
                </div>
                <div class="card__badge top right">
                  ${badgeHTML}
                </div>
              </div>
            </div>

            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5" id="title-predictive-search-${productId}">
                  <a href="/products/${productHandle}" 
                     id="CardLink-predictive-search-${productId}" 
                     class="full-unstyled-link" 
                     data-predictive-search-text
                     aria-labelledby="CardLink-predictive-search-${productId}">
                    ${productTitle}
                  </a>
                </h3>
                
                ${variantsHTML ? `
                  <ul class="card-option">
                    ${variantsHTML}
                  </ul>
                ` : ''}
                
                <div class="card-information">
                  <span class="caption-large light"></span>
                </div>
              </div>

              <div class="quick-add no-js-hidden hidden">
                <modal-opener data-modal="#QuickAdd-${productId}">
                  <button id="quick-add-predictive-search${productId}-submit" 
                          type="submit" 
                          name="add" 
                          class="quick-add__submit button button--full-width button--secondary" 
                          aria-haspopup="dialog" 
                          aria-labelledby="quick-add-predictive-search${productId}-submit title-predictive-search-${productId}" 
                          data-product-url="/products/${productHandle}">
                    Choose options
                    <div class="loading__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                    </div>
                  </button>
                </modal-opener>
              </div>

              <div class="card__badge top right"></div>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return `£${amount.toFixed(2)}`;
  }

  attachQuickBuyListeners() {
    const quickViewButtons = this.predictiveSearchResults.querySelectorAll('.js-pro-cart-button');

    quickViewButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const card = e.currentTarget.closest('.card--standard');
        if (!card) return;

        const quickAddButton = card.querySelector('.quick-add__submit');
        if (quickAddButton) {
          const cleanClick = new Event('click', { bubbles: true });
          quickAddButton.dispatchEvent(cleanClick);
        }
      });
    });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  highlightMatches(searchTerm) {
    if (!searchTerm) return;

    const regex = new RegExp(`(${searchTerm})`, 'ig');

    this.predictiveSearchResults
      .querySelectorAll('[data-predictive-search-text]')
      .forEach((el) => {
        const originalText = el.textContent;

        if (el.innerHTML.includes('<mark>')) return;

        el.innerHTML = originalText.replace(regex, '<mark>$1</mark>');
      });
  }

  showRandomProductsWhenNoResults() {
    const container = this.predictiveSearchResults;
    if (!container) return;

    const noResults = container.querySelector('.predictive-search__recommendations');
    if (!noResults) return;
   
    const items = Array.from(
      container.querySelectorAll('.random-product-predictive-search')
    );

    if (!items.length) return;

    items.forEach(li => li.classList.remove('is-visible'));

    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.slice(0, 5).forEach(li => {
      li.classList.add('is-visible');
    });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
    this.highlightMatches(this.searchTerm);
    
    const quickViewButtons = this.predictiveSearchResults.querySelectorAll('.js-pro-cart-button');
    this.showRandomProductsWhenNoResults();

    quickViewButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const card = e.currentTarget.closest('.card--standard');
        if (!card) return;

        const quickAddButton = card.querySelector('.quick-add__submit');
        if (quickAddButton) {
          const cleanClick = new Event('click', { bubbles: true });
          quickAddButton.dispatchEvent(cleanClick);
        }
      });
    });
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const countElement = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (countElement) {
      this.setLiveRegionText(countElement.textContent);
    }
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
